import React from 'react';
import MainTable from './components/MainTable';

const CorporateApproval = () => {
  return <MainTable />;
};

export default CorporateApproval;
